<template>
    <div>
        <div v-if="media">
            <ion-avatar class="big-avatar" v-if="thumbnail">
                <img :src="thumbnail">
            </ion-avatar>
            <div v-else class="media-info">
                Your photo is ready for upload
            </div>
            <ion-button shape="round" v-on:click="resetMedia">{{buttonAction}} Another Picture</ion-button>
        </div>
        <div v-else>
            <div v-if="isAndroid">
                <ion-button shape="round" v-on:click="takePicture()">{{buttonText}}</ion-button>
            </div>
            <div v-else-if="isIos" class="media-recorder">
                <!-- Doesn't allow upload -->
                <div class="record-button">
                    <input type="file" accept="image/*" class="uploader" v-on:change="onUpload($event)">
                    {{buttonText}}
                </div>
            </div>
            <div v-else>
                <image-upload :set-media="setMedia" />
            </div>
        </div>
    </div>
</template>

<script>

import {device} from '@/mixins/device';
import ImageUpload from '@/components/ImageUpload.vue';

export default {
    name: 'image',
    created : function () {
        this.type = 'image';
    },
    props : {
        clearMedia : Function,
        setMedia : Function,
        media : {
            type : String|null,
            default : null
        },
        thumbnail : {
            type : String|null,
            default : null
        },
    },
    components: {
        ImageUpload
    },
    mixins : [device],
    methods : {
        resetMedia : function () {
            this.clearMedia();
        },
        onUpload : function (event) {
            // console.log('image file uploaded', event);
            this.setMedia(event.target.files[0]);
        },
        takePicture : function () {
            let self = this;
            return this.$ionic.alertController.create({
                header  : 'Take a Photo',
                message : 'Would you like to take a photo with your camera, or upload one from your gallery?',
                buttons : [
                    {
                        text : 'Camera',
                        handler : () => {
                            self.clearMedia();
                            self.cordovaImage(Camera.PictureSourceType.CAMERA);
                        },
                    },
                    {
                        text: 'Gallery',
                        handler: () => {
                            self.clearMedia();
                            self.cordovaImage(Camera.PictureSourceType.PHOTOLIBRARY);
                        },
                    },
                ],
                })
                .then(a => a.present());
        },
        cordovaImage : function (source_type) {
            let self = this;
            var options = {
                quality            : 80,
                destinationType    : Camera.DestinationType.NATIVE_URI,
                sourceType         : source_type,
                encodingType       : Camera.EncodingType.JPEG,
                mediaType          : Camera.MediaType.PICTURE,
                allowEdit          : false,
                correctOrientation : true
            };
            // console.log('Getting image from phone', options);
            navigator.camera.getPicture (
                function cameraSuccess(imageUri) {
                    // console.log('image URI is', imageUri);
                    self.fileUrlToBlob(imageUri);
                },
                function cameraError(error) {
                    console.debug("Unable to get image", error);
                }, options
            );
        }
    }
}
</script>